import type { FileReplicationFailedResult } from "@/services/abstract/poc/messaging.service.interface";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-replication-failed' });

export const createFileReplicationFailedHandler = (): MessageHandler<FileReplicationFailedResult> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-replication-failed',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileReplicationFailedResult => {
    if (message.type !== 'file-replication-failed') {
      throw new Error(`Invalid message type: expected 'file-replication-failed', got '${message.type}'`);
    }

    const { cid, sixId, reason, targetPeerId, sender, timestamp } = message;
    log.info('Received file-replication-failed for CID:', cid, 'sixId:', sixId, 'reason:', reason, 'from', sender);

    return {
      cid,
      sixId,
      reason,
      targetPeerId,
      sender,
      messageTimestamp: timestamp
    };
  }
});
